import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'formik';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Button from '@material-ui/core/Button';
import combineStyles from '../../../utils/combineStyles';
import LayoutStyles from '../../../styles/layout';
import SpacingStyles from '../../../styles/helpers/spacing';
import ButtonStyles from '../../../styles/button';
import FormItemContainer from '../../Global/Containers/FormItemContainer';
import Grid from '@material-ui/core/Grid';
import GridItem from '../../Global/GridItem';
import ReferenceDropdown from './References/ReferenceDropdown';
import ReferenceTextField from './References/ReferenceTextField';
import ReferenceMultiSelect from './References/ReferenceMultiSelect';
import _isEqual from 'lodash/isEqual';
import AddReferenceModal from './References/AddReferenceModal';
import { buildReferenceField } from '../../../pages/shipment/helpers';

export class References extends Component {
  static propTypes = {
    values: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    referenceFields: PropTypes.object.isRequired,
    handleValidateField: PropTypes.func.isRequired
  };

  state = {
    visibleReferenceFields: [],
    formattedValues: {},
    displayAddReferenceModal: false
  };
  componentDidMount() {
    const { referenceFields, values } = this.props;
    const formattedValues = this._arrangeValues(values);
    this.setState({
      visibleReferenceFields: referenceFields.viewable,
      formattedValues,
      availableReferenceFields: referenceFields.available
    });
  }
  componentDidUpdate(prevProps) {
    const { values } = this.props;

    if (!_isEqual(prevProps.values, this.props.values)) {
      const formattedValues = this._arrangeValues(values);
      this.setState({ formattedValues });
    }
  }
  _arrangeValues = values => {
    const allValues = {};
    values.forEach(value => {
      allValues[value.stringId] = value;
    });

    return allValues;
  };
  _handleAddReferenceField = (arrayHelpers, availableFieldIndex) => {
    const {
      visibleReferenceFields,
      availableReferenceFields,
      formattedValues
    } = this.state;

    const newField = availableReferenceFields[availableFieldIndex];
    const updatedAvailableFieldList = availableReferenceFields.splice(
      availableFieldIndex,
      1
    );
    visibleReferenceFields.push(newField);
    const newFieldValue = buildReferenceField(newField, []);
    formattedValues[newField.stringId] = newFieldValue.value;
    arrayHelpers.push(newFieldValue.value);
    this.setState({
      availableReferenceFields: updatedAvailableFieldList,
      visibleReferenceFields,
      formattedValues
    });
  };
  toggleDisplayAddReferenceModal = display => {
    this.setState({ displayAddReferenceModal: display });
  };
  render() {
    const { classes, t, onChange, handleValidateField } = this.props;
    const {
      visibleReferenceFields,
      formattedValues,
      availableReferenceFields,
      displayAddReferenceModal
    } = this.state;
    return (
      <FormItemContainer title={t('References')}>
        <Grid container spacing={16}>
          <FieldArray
            name={`references`}
            validateOnChange={false}
            render={arrayHelpers => {
              return (
                <Fragment>
                  {visibleReferenceFields.map((field, fieldNumber) => {
                    if (field.customFieldTypeId === 'DROP_DOWN') {
                      return (
                        <GridItem lg={3} key={fieldNumber}>
                          <ReferenceDropdown
                            fieldNumber={fieldNumber}
                            fieldOptions={field}
                            onChange={onChange}
                            values={formattedValues[field.stringId].values}
                            validateField={handleValidateField}
                          />
                        </GridItem>
                      );
                    }
                    if (field.customFieldTypeId === 'TEXT') {
                      return (
                        <GridItem lg={3} key={fieldNumber}>
                          <ReferenceTextField
                            fieldNumber={fieldNumber}
                            fieldOptions={field}
                            onChange={onChange}
                            values={formattedValues[field.stringId].values}
                            validateField={handleValidateField}
                          />
                        </GridItem>
                      );
                    }
                    if (field.customFieldTypeId === 'COMBO') {
                      return (
                        <GridItem lg={6} key={fieldNumber}>
                          <ReferenceMultiSelect
                            fieldNumber={fieldNumber}
                            fieldOptions={field}
                            onChange={onChange}
                            values={formattedValues[field.stringId].values}
                            validateField={handleValidateField}
                          />
                        </GridItem>
                      );
                    }
                    return '';
                  })}
                  <Grid item lg={12}>
                    <Button
                      variant="outlined"
                      className={classnames(
                        classes.outlinedButton,
                        classes.noMarginBottom
                      )}
                      onClick={() => {
                        this.toggleDisplayAddReferenceModal(true);
                      }}
                      color={'primary'}
                      classes={{ label: classes.buttonLabel }}
                    >
                      {t('Add Reference Field')}
                    </Button>
                  </Grid>
                  <AddReferenceModal
                    open={displayAddReferenceModal}
                    availableFields={availableReferenceFields}
                    onClose={() => {
                      this.toggleDisplayAddReferenceModal(false);
                    }}
                    onSave={fieldIndex => {
                      this._handleAddReferenceField(arrayHelpers, fieldIndex);
                    }}
                  />
                </Fragment>
              );
            }}
          />
        </Grid>
      </FormItemContainer>
    );
  }
}

const ReferencesWithTranslations = withNamespaces()(References);
export default withStyles(
  combineStyles(LayoutStyles, SpacingStyles, ButtonStyles)
)(ReferencesWithTranslations);
